import { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * QueryClient configured to match AngularJS caching behavior:
 * - Data persists across navigation (no refetch on mount if fresh)
 * - No automatic refetch on window focus or reconnect
 * - Stale time set to prevent unnecessary refetches during session
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Match AngularJS: data remains fresh for 5 minutes by default
      staleTime: 5 * 60 * 1000,
      // Match AngularJS: cache persists for 30 minutes
      gcTime: 30 * 60 * 1000,
      // Match AngularJS: don't refetch on window focus
      refetchOnWindowFocus: false,
      // Match AngularJS: don't refetch on reconnect
      refetchOnReconnect: false,
      // Only refetch on mount if data is stale
      refetchOnMount: true,
      // Don't retry failed requests automatically
      retry: false,
    },
  },
});

export function QueryProvider({ children }: QueryProviderProps) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
